import immutablePersistenceTransform from '../Services/ImmutablePersistenceTransform';

// More info here:  https://shift.infinite.red/shipping-persistant-reducers-7341691232b1
const REDUX_PERSIST = {
    active: true,
    reducerVersion: '1.0',
    storeConfig: {
        storage: localStorage,
        blacklist: ['login', 'search', 'nav'], // reducer keys that you do NOT want stored to persistence here
        // whitelist: [], Optionally, just specify the keys you DO want stored to
        // persistence. An empty array means 'don't store any reducers' -> infinitered/ignite#409
        transforms: [immutablePersistenceTransform]
    }
}

export default REDUX_PERSIST



// WEBPACK FOOTER //
// ./src/Config/ReduxPersist.js